<template>
  <fieldset>
    <legend>
      <button
        class="collapseToggle"
        type="button"
        :data-collapse="placeHolder"
        aria-expanded="true"
        :aria-controls="placeHolder"
        @click="toggleCollapse(placeHolder)"
      >{{ title }}</button>
    </legend>

    <div :id="placeHolder" class="collapse collapse--visible show">
      <div v-for="bucket in expandedBuckets" v-bind:key="bucket.value" class="checkbox">
        <input 
          :id="`${placeHolder}${bucket.value}`"
          type="checkbox"
          v-model="selectedOptions"
          :value="bucket.value"
        />
        <label class="fs_label" :for="`${placeHolder}${bucket.value}`">{{bucket.value}} ({{bucket.count}})</label>
      </div>

      <div v-if="facetsBuckets.length > maxBuckets">
        <button
          class="btn btn-light btn-sm btn-block"
          type="button"
          :data-collapse="`${placeHolder}All`"
          data-collapse-remove
          aria-expanded="false"
          :aria-controls="`${placeHolder}All`"
          @click="toggleCollapse(`${placeHolder}All`)"
        >Show More...</button>

        <div :id="`${placeHolder}All`" class="collapse">
          <div
            v-for="bucket in facetsBuckets.slice(maxBuckets)"
            v-bind:key="bucket.value"
            class="checkbox"
          >
            <input
              :id="`${placeHolder}${bucket.value}`"
              type="checkbox"
              v-model="selectedOptions"
              :value="bucket.value"
            />
            <label :for="`${placeHolder}${bucket.value}`">{{bucket.value}} ({{bucket.count}})</label>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Fieldset",
  data() {
    return {
      maxBuckets: process.env.VUE_APP_STATIC_EXPANDED_BUCKETS_MAX
    };
  },
  props: {
    title: {
      type: String,
      default: () => ""
    },
    placeHolder: {
      type: String,
      default: () => ""
    },
    model: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    toggleCollapse(collapseId) {
      var collapse = event.srcElement;
      document.getElementById(collapseId).classList.toggle("collapse--visible");

      if (
        document
          .getElementById(collapseId)
          .classList.contains("collapse--visible")
      ) {
        collapse.setAttribute("aria-expanded", "true");
        document.getElementById(collapseId).classList.add("show");
      } else {
        collapse.setAttribute("aria-expanded", "false");
      }
      if (event.srcElement.hasAttribute("data-collapse-remove")) {
        event.srcElement.parentNode.removeChild(event.srcElement);
      }
    }
  },
  computed: {
    ...mapState(["facets"]),
    selectedOptions: {
      get: function() {
        return this.model;
      },
      set: function(newValue) {
        this.$emit("update:model", newValue);
      }
    },
    facetsBuckets() {
      if(!this.facets) return []
      switch (this.placeHolder) {              
        case "filterInsurance":         
          return this.facets.liabilityInsurance && this.facets.liabilityInsurance.buckets || [];
        case "filterRegion":
          return this.facets.serviceRegions && this.facets.serviceRegions.buckets || [];
        case "filterProvince":
          return this.facets.provinces && this.facets.provinces.buckets || [];
        case "filterAssociation":          
          return this.facets.associations && this.facets.associations.buckets || [];
        default:
          return [];
      }
    },
    expandedBuckets(){
      if(this.facetsBuckets && this.facetsBuckets.length > this.maxBuckets)
        return this.facetsBuckets.slice(0,this.maxBuckets);
      return this.facetsBuckets;
    }
  }
};
</script>
